// Mock data for Harmonie Féminine website

export const siteData = {
  siteName: "Harmonie Féminine",
  subtitle: "Centre de nutrition & santé corps–cœur",
  author: "par Nutri Centre Riviera",
  tagline: "Centre pluridisciplinaire dédié à la santé féminine, alliant nutrition, suivi médical et équilibre émotionnel.",
  
  cta: {
    primary: "Prendre rendez-vous",
    subtext: "En quelques clics",
    url: "https://www.onedoc.ch/fr/cabinet-de-groupe/vevey/ebdj4/nutri-centre-riviera"
  },

  services: [
    {
      id: 1,
      title: "Nutrition & bilan métabolique",
      description: "Analyse complète du métabolisme, des habitudes alimentaires et des besoins personnalisés.",
      icon: "activity"
    },
    {
      id: 2,
      title: "Bilan impédancemétrie",
      description: "Mesure précise de la composition corporelle (graisse, masse musculaire, hydratation).",
      icon: "gauge"
    },
    {
      id: 3,
      title: "Nutrition & santé cardiovasculaire",
      description: "Accompagnement nutritionnel en lien avec la santé cardiaque et le suivi médical.",
      icon: "heart-pulse"
    },
    {
      id: 4,
      title: "Équilibre émotionnel corps–cœur",
      description: "Accompagnement pour reconnecter le corps, les émotions et les comportements alimentaires.",
      icon: "sparkles"
    }
  ],

  aboutCenter: {
    title: "Le Centre",
    description: "Harmonie Féminine est un centre de santé dédié à la prise en charge globale de la femme.\nNous associons nutrition, suivi médical et accompagnement émotionnel afin de proposer une approche complète, durable et personnalisée.\n\nLe centre regroupe différents professionnels de santé et a pour vocation de se développer afin d'offrir une prise en charge pluridisciplinaire."
  },

  consultations: [
    "Consultation de nutrition",
    "Bilan nutritionnel complet",
    "Bilan impédancemétrique",
    "Suivi métabolique et hormonal",
    "Nutrition & santé cardiovasculaire",
    "Accompagnement corps–cœur",
    "Suivi perte de poids durable",
    "SOPK & troubles hormonaux"
  ],

  appointmentSection: {
    title: "Prendre rendez-vous",
    description: "Prenez rendez-vous facilement en ligne pour une première consultation ou un suivi personnalisé."
  },

  team: [
    {
      id: 1,
      name: "Mme Zara Nawid",
      role: "Nutritionniste diplômée – Thérapeute en nutrition MCO – ASCA & RME",
      speciality: "Spécialiste du SOPK, des hormones féminines et de la perte de poids",
      description: "Parcours universitaire en biologie, plus de 10 ans d'expérience dans le domaine médical et plusieurs années de pratique en nutrition. J'aide les femmes à retrouver un équilibre hormonal, améliorer leur métabolisme et atteindre un poids durablement stable grâce à un accompagnement personnalisé.",
      image: "/images/zara-nawid.webp"
    },
    {
      id: 2,
      name: "",
      role: "Diététicienne-nutritionniste",
      speciality: "Nutrition comportementale et équilibre alimentaire",
      description: "Experte en troubles du comportement alimentaire et accompagnement pour une relation saine avec la nourriture.",
      image: ""
    },
    {
      id: 3,
      name: "",
      role: "Spécialiste en cardiologie, Médecine interne générale, FMH",
      speciality: "Cardiologie et pathologie vasculaire",
      description: "Exploration cardiovasculaire non invasive (Echodoppler, Ergométrie, Remler, Holter rythmique, contrôles pace-maker, troubles du sommeil). Pose et suivi des Holters implantables.",
      image: ""
    }
  ],

  contact: {
    address: "Av. du Général-Guisan 26, 1800 Vevey",
    phone: "076 779 93 02",
    email: "nutririviera@gmail.com",
    hours: {
      weekdays: "Lundi - Vendredi: 8h00 - 18h00",
      saturday: "Samedi: 9h00 - 13h00",
      sunday: "Dimanche: Fermé"
    }
  },

  images: {
    hero: "/images/hero-home.webp",
    about: "/images/approche.webp",
    services: "https://images.pexels.com/photos/15319046/pexels-photo-15319046.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940"
  }
};
